import React from "react";
import Tabs from "../../../components/common/Tabs";
import { viewDetailsTabsData } from "../../../config/tabsConfig";
import BreadCrumbs from "../../../components/common/BreadCrumbs/BreadCrumbs";
import { useNavigate } from "react-router-dom";
import { trackCustomPageView, trackNavigation } from '../../../services/analytics';

const ViewDetailsTabList: React.FC = () => {
  const navigate = useNavigate();
  const handleBreadcrumbPrevious = () => {
    console.log('📊 Analytics: Navigate back to upload document');
    trackNavigation('details-tabs', 'upload-document', 'back');
    trackCustomPageView('upload-document-summary');
    navigate("/citizenship/upload-document");
  };

  return (
    <div className="lg:!px-[160px] min-h[67vh]mx-auto px-4 py-6 sm:mx-[20px]!">
      <BreadCrumbs
        previousPage="Back to view my details and upload documents"
        currentPage=""
        onPreviousClick={handleBreadcrumbPrevious}
      />

      <h1 className="h1 !mt-[32px] !mb-[32px]">Viewing details</h1>
      <Tabs tabs={viewDetailsTabsData} />
    </div>
  );
};

export default ViewDetailsTabList;
